<div class="loading-overlay" [class.show]="loading" [class.full]="mode === 'full'">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
